(function() {
    angular
        .module('app')
        .directive('gMaps', gMaps);

    gMaps.$inject = ['$timeout'];

    function gMaps($timeout) {
        return {
            restrict: 'A',
            scope: {
                "heatmapdata":'=',
                "ac":"=",
            },
            link: function(scope, element, $attrs) {

                return $timeout(function() {
                    console.log(scope.heatmapdata);

                    var colombia = new google.maps.LatLng(6.230833 , -75.590553);

                    var geocoder = new google.maps.Geocoder();

                    /*scope.localizacionActual = function(){
                        var initCoords=function() {
                            if ( navigator.geolocation ) {
                                navigator.geolocation.getCurrentPosition(showPosition, showError);
                            }
                        }
                        var showError=function(e){
                            alert(e)
                        };

                        var showPosition=function( position ) {
                            var lat = position.coords.latitude;
                            var long =  position.coords.longitude;
                            var latlng=new google.maps.LatLng(lat,long);
                            map.setPosition( latlng );

                        }
                        initCoords();
                      
                    }
                    scope.localizacionActual();*/


                    var myStyle = [
                        /*{
                            featureType: "administrative.country",
                            elementType: "labels",
                            stylers: [
                              { visibility: "off" }
                            ]
                          },{
                            featureType: "administrative.province",
                            elementType: "labels",
                            stylers: [
                              { visibility: "off" }
                            ]
                          },*/
                        /*{
                            featureType: "water",
                            elementType: "labels",
                            stylers: [
                              //{ saturation: -20 },
                              { hue: "#00A8B0" }
                            ]
                        },*/
                        {
                            featureType: "water",
                            elementType: "geometry.fill",

                            stylers: [
                              //{ lightness: -50 },
                              //{ hue: "#0f6855" },
                              //{ saturation: 5 },
                                //{ lightness: 60 }
                              //{ gamma: 0.5 }
                              //{ saturation: 0 },
                              { "color":"#cbd8d5" }
                            ]
                          },
                      {
                        featureType: "all",
                        elementType: "all",
                        stylers: [
                          //{ invert_lightness: true }
                        ]
                      }/*,{
                        featureType: "administrative",
                        elementType: "labels",
                        stylers: [
                          { visibility: "off" }
                        ]
                      }*/,{
                        featureType: "landscape",
                        elementType: "all",
                        stylers: [
                          { visibility: "off" }
                        ]
                      },{
                        featureType: "poi",
                        elementType: "all",
                        stylers: [
                          { visibility: "off" }
                        ]
                      },{
                        featureType: "road",
                        elementType: "all",
                        stylers: [
                          { visibility: "off" }
                        ]
                      },{
                        featureType: "transit",
                        elementType: "all",
                        stylers: [
                          { visibility: "off" }
                        ]
                      },{
                        featureType: "water",
                        elementType: "labels",
                        stylers: [
                          { visibility: "off" }
                        ]
                      }/*,{
                        featureType: "water",
                        elementType: "geometry",
                        stylers: [
                          { lightness: 50 }
                        ]
                      }*/
                    ];

                    var styledMapOptions = {
                     name: "Urano map"
                  }

                  var mcOptions = {styles: [{
                    height: 53,
                    url: "/images/m1.png",
                    width: 53
                    },
                    {
                    height: 56,
                    url: "/images/m1.png",
                    width: 56
                    },
                    {
                    height: 66,
                    url: "/images/m1.png",
                    width: 66
                    },
                    {
                    height: 78,
                    url: "/images/m1.png",
                    width: 78
                    },
                    {
                    height: 90,
                    url: "/images/m1.png",
                    width: 90
                    }]}

                  var usRoadMapType = new google.maps.StyledMapType(
                      myStyle, styledMapOptions);
                      
                    map = new google.maps.Map(document.getElementById('map'), {
                      //center: colombia,
                      zoom: (scope.ac.city!='-1' ? 11 : 7),
                      /*mapTypeControlOptions: {
                         mapTypeIds: ['mystyle', google.maps.MapTypeId.ROADMAP, google.maps.MapTypeId.TERRAIN]
                      },*/
                      //mapTypeId: 'mystyle'
                      
                    });

                   
                    var heatmap = new google.maps.visualization.HeatmapLayer({
                      data: scope.heatmapdata
                    });
                    heatmap.set("radius", 25);
                    var mapType = "myStyle";
                    map.mapTypes.set('myStyle', usRoadMapType);
                    map.setMapTypeId('myStyle');

                    /*const markers = scope.heatmapdata.map((position, i) => {
                        var latLng = new google.maps.LatLng(position.lat,
              position.lng);
                        console.log(position);
                    const label = "";//labels[i % labels.length];
                    const marker = new google.maps.Marker({
                      position:latLng,
                      label,
                      mcOptions
                    });

                    // markers can only be keyboard focusable when they have click listeners
                    // open info window when marker is clicked
                    marker.addListener("click", () => {
                      infoWindow.setContent(label);
                      infoWindow.open(map, marker);
                    });

                    return marker;
                  });

                  // Add a marker clusterer to manage the markers.
                  var markerCluster = new MarkerClusterer(map, markers);*/

                    /*var markers = [];
                    angular.forEach(scope.heatmapdata, function (value, key) {
                        markers.push(new google.maps.Marker({
                        position: value.location,
                        //map,
                        title: "Hello World!",
                      }));
                    })
                    console.log(markers);
                    new MarkerClusterer({ markers, map });*/

                    //map.setMapTypeId(google.maps.MapTypeId["ROADMAP"]); // same example with hybrid


                    heatmap.setMap(map);
                        
                    scope.$watch("ac.country",function(){
                        console.log("ac.country");
                        $timeout(function(){
                            if(scope.ac.city=='-1'){
                                //scope.ac.city = "-1";
                                geocoder.geocode({
                                    'address': scope.ac.country
                                }, function(results, status) {
                                  if (status == google.maps.GeocoderStatus.OK) {
                                    map.setCenter(results[0].geometry.location);
                                  } else {
                                    alert('Geocode error: ' + status);
                                  }
                                });
                            }

                            
                        })
                    })


                    scope.$watch("ac.showMap",function(newValue, oldValue){
                        console.log("ac.country");
                        if(newValue){
                            console.log("CAMBIO");
                            $timeout(function(){
                                //heatmap.setMap(null)
                                heatmap.setMap(null);
                                heatmap.setData(scope.heatmapdata);

                                heatmap = new google.maps.visualization.HeatmapLayer({
                                  data: scope.heatmapdata
                                });
                                heatmap.set("radius", 25);
                                var mapType = "myStyle";
                                map.mapTypes.set('myStyle', usRoadMapType);
                                map.setMapTypeId('myStyle');

                                heatmap.setMap(map);

                                if(scope.ac.city!='-1'){
                                    console.log("city",scope.ac.city);
                                    geocoder.geocode({
                                        'address': scope.ac.city
                                    }, function(results, status) {
                                      if (status == google.maps.GeocoderStatus.OK) {
                                        map.setCenter(results[0].geometry.location);
                                      } else {
                                        //alert('Geocode error: ' + status);
                                      }
                                    });
                                }
                            })
                        }
                    })

                    scope.$watch("ac.city",function(){
                        $timeout(function(){
                                console.log("city",scope.ac.city);
                            if(scope.ac.city!='-1'){
                                console.log("city",scope.ac.city+", "+scope.ac.country);
                                geocoder.geocode({
                                    'address': scope.ac.city+", "+scope.ac.country
                                }, function(results, status) {
                                  console.log("results",results);
                                  if (status == google.maps.GeocoderStatus.OK) {
                                    console.log("zoom 11");
                                    map.setZoom(11);
                                    map.setCenter(results[0].geometry.location);

                                  } else {
                                    //alert('Geocode error: ' + status);
                                  }
                                });
                            }else{
                                    map.setZoom(7);

                            }

                            
                        })
                    })


                });

            }};
    }

})();
